import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../routes'
import { Button, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { LanguageConsumer } from '../../context/LanguageContext'
import { InvoicesListingConsumer } from '../../context/InvoicesListingContext'
import TableWithFilter from '../InvoicesHelpers/TableWithFilter'
import { FormLoader } from '../Loader/FormLoader'
import { AuthConsumer } from '../../context/AuthContext'
import TaxpayerSubscriptionWarning from './TaxpayerSubscriptionWarning'
import { Tabs, Tab, AppBar, Box } from '@material-ui/core'

const InvoicesPageContent = () => {
  const classes = useStyles()

  let history = useHistory()
  const [open, setOpen] = React.useState(false)
  const menuAnchorRef = React.useRef(null)

  const handleButtonMenuToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (menuAnchorRef.current && menuAnchorRef.current?.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const handleMenuItemClick = (event, link) => {
    if (!!link) {
      history.push({
        pathname: link
      })
    }
    handleClose(event)
  }
  const invoiceAddTypes = [
    {
      title: <FormattedMessage id='InvoicesPage.addNew.drafts'/>,
      link: NamedRoutes.drafts
    },
    {
      title: <FormattedMessage id='InvoicesPage.addNew.templates'/>,
      link: NamedRoutes.templates
    }
  ]

  function TabPanel (props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box py={3}>
            {children}
          </Box>
        )}
      </div>
    )
  }

  function a11yProps (index) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`
    }
  }

  return (
    <AuthConsumer>
      {({ taxpayerData, userPermissions, taxpayerSubscriptionsData, taxpayerSubscriptionsLoading }) => (
        <>
          <PageTitle
            title={<FormattedMessage id='InvoicesPageContent.PageTitle'/>}
            disabledButton={!(taxpayerSubscriptionsData?.hasValidSubscription && taxpayerSubscriptionsData?.hasQuota)}
            addButtonRoute={NamedRoutes.newInvoice}
            addButtonText={<FormattedMessage id='InvoicesPage.addNew'/>}
            addButtonIcon={<AddOutlinedIcon/>}
            extraButtons={
              <>
                <ButtonGroup color="secondary" ref={menuAnchorRef} aria-label="menu button"
                             disabled={!(taxpayerSubscriptionsData?.hasValidSubscription && taxpayerSubscriptionsData?.hasQuota)}>
                  <Button size={'large'} variant={'contained'} color={'secondary'} component={Link}
                          to={NamedRoutes.newInvoice} className={classes.addBtn} startIcon={<AddOutlinedIcon/>}>
                    <FormattedMessage id='InvoicesPage.addNew'/>
                  </Button>
                  <Button size={'small'} variant={'contained'} color={'secondary'}
                          aria-controls={open ? 'actions-button-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-label="select invoice create type"
                          aria-haspopup="menu"
                          onClick={handleButtonMenuToggle}
                  >
                    <ArrowDropDownIcon/>
                  </Button>
                </ButtonGroup>
                <Popper open={open} className={classes.menuPopper} anchorEl={menuAnchorRef.current} role={undefined}
                        transition
                        disablePortal>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{ transformOrigin: placement === 'bottom' ? 'right top' : 'right bottom' }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id="actions-button-menu">
                            {invoiceAddTypes.map((type, index) => (
                              <MenuItem
                                key={index}
                                onClick={(event) => handleMenuItemClick(event, type.link)}
                              >
                                {type.title}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>}
          />

          {!taxpayerSubscriptionsLoading && !taxpayerSubscriptionsData?.hasValidSubscription &&
          <TaxpayerSubscriptionWarning taxpayerSubscriptionsData={taxpayerSubscriptionsData}/>}
          <LanguageConsumer>
            {({ locale }) => (
              <InvoicesListingConsumer>
                {({
                    listingCount, listingRowsPerPage, listingPage, handleChangeListingPage, handleChangeListingRowsPerPage,
                    handleListingFilterSubmit, listingData, listingLoading, handleInvoiceTypeFilterSubmit, listingLoadingEInvoice, tabValue,
                    listingDataEnvoice, handleTabChange, tabEntityName, invoiceTypeFilterBackup, handleTokenPagination, continuationTokens, currentIndex,listingFiltersBackup
                  }) => (
                  <div className={classes.tabsWrapper}>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="standard"
                        indicatorColor="secondary"
                        textColor="secondary"
                      >
                        <Tab label={<FormattedMessage id='InvoicesPage.label.tab.sp'/>} {...a11yProps(0)} />
                        <Tab label={<FormattedMessage id='InvoicesPage.label.tab.ms'/>} {...a11yProps(1)} />
                      </Tabs>
                    </AppBar>
                    <TabPanel value={tabValue} index={0}>
                      <div className={'listing-wrapper'}>
                        <TableWithFilter
                          listingData={listingData}
                          listingCount={listingCount}
                          listingRowsPerPage={listingRowsPerPage}
                          listingPage={listingPage}
                          handleChangeListingPage={handleChangeListingPage}
                          handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                          handleListingFilterSubmit={handleListingFilterSubmit}
                          handleInvoiceTypeFilterSubmit={handleInvoiceTypeFilterSubmit}
                          taxpayerData={taxpayerData}
                          userPermissions={userPermissions}
                          locale={locale}
                          tabEntityName={tabEntityName}
                          listingFiltersBackup={listingFiltersBackup}
                        />
                        {(!!listingLoading || !!taxpayerSubscriptionsLoading) && <FormLoader loading={true}/>}
                      </div>
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                      <div className={'listing-wrapper'}>
                        <TableWithFilter
                          listingData={listingDataEnvoice}
                          listingCount={listingCount}
                          listingRowsPerPage={listingRowsPerPage}
                          listingPage={listingPage}
                          handleChangeListingPage={handleTokenPagination}
                          handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                          handleListingFilterSubmit={handleListingFilterSubmit}
                          handleInvoiceTypeFilterSubmit={handleInvoiceTypeFilterSubmit}
                          taxpayerData={taxpayerData}
                          userPermissions={userPermissions}
                          locale={locale}
                          tabEntityName={tabEntityName}
                          invoiceTypeFilterBackup={invoiceTypeFilterBackup}
                          hasContinuationToken
                          noPagination
                          continuationTokens={continuationTokens}
                          currentIndex={currentIndex}
                          listingFiltersBackup={listingFiltersBackup}
                        />
                        {(!!listingLoadingEInvoice || !!taxpayerSubscriptionsLoading) && <FormLoader loading={true}/>}
                      </div>
                    </TabPanel>
                  </div>
                )}
              </InvoicesListingConsumer>
            )}
          </LanguageConsumer>
        </>
      )}
    </AuthConsumer>
  )
}

export default InvoicesPageContent
